"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
function Loading(_a) {
    var noCentering = _a.noCentering, color = _a.color;
    return (react_1.default.createElement("div", { className: "eva-list-loading-indicator" },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('loading-tracker', {
                'loading-tracker--no-centering': noCentering,
            }) },
            react_1.default.createElement("div", { className: "page-loading-icon", style: { '--loading-color': color } }))));
}
exports.default = Loading;
